import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgEject = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M18.296 17.92c.451 0 .704.322.704.584v1.333c0 .262-.253.584-.704.584H5.205c-.452 0-.705-.322-.705-.584v-1.333c0-.262.253-.583.705-.583zm2.204.584c0-1.21-1.05-2.083-2.204-2.083H5.205C4.05 16.42 3 17.293 3 18.504v1.333c0 1.211 1.05 2.084 2.205 2.084h13.09c1.155 0 2.205-.873 2.205-2.084zM13.104 3.642a1.75 1.75 0 0 0-2.708 0l-6.89 8.42c-.935 1.143-.122 2.859 1.354 2.859h13.78c1.476 0 2.29-1.716 1.354-2.858zm-1.547.95a.25.25 0 0 1 .386 0l6.89 8.42a.25.25 0 0 1-.193.409H4.86a.25.25 0 0 1-.193-.409z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgEject;
